const MAX_STEPS = 32;

export function hasNextPage(end, stepsLength) {
    return end + MAX_STEPS <= stepsLength;
}

export function hasPreviousPage(start) {
    return start - MAX_STEPS >= 0;
}

export function getNextPageStart(start) {
    return start + MAX_STEPS;
}

export function getPreviousPageStart(start) {
    return start - MAX_STEPS;
}

export function getNextPageEnd(end) {
    return end + MAX_STEPS;
}

export function getPreviousPageEnd(end) {
    return end - MAX_STEPS;
}


export function getCurrentPage(start) {
    return 1 + Math.floor(start / 32);
}

export function getTotalPages(stepsLength) {
    if (stepsLength < MAX_STEPS) {
        return 1;
    }
    return  Math.floor(stepsLength / 32);
}

export function getPagination(currentStep, stepsLength) {
    let start = 0;
    let end = stepsLength;

    if (currentStep % MAX_STEPS == 0) {
        start = currentStep;
        end = currentStep + MAX_STEPS;
    } else {
        // find the last page
        start = Math.floor(currentStep / 32) * 32;
        end = (Math.floor(currentStep / 32) + 1) * 32;
    }

    if (end >= stepsLength) {
        end = stepsLength;
    }

    return {
        start: start,
        end: end
    };
}
